import React, { Component } from "react";
import { Row, Col, Tooltip } from "antd";
import RecurringIcon from "../../../../../../../assets/icons/recurring.svg";
import {
  LabelDataHeading,
  ValueDataHeading,
  Underlined,
  ViewMoreButton,
  ContentDivider
} from "../../../style";
import { cancelTxnSchedule } from "../../../actions";
import history from "../../../../../../../history/history";
import moment from "moment";
import { AlertMessagePrimary } from "../../AlertPopUp/AlertPopUp";
import { connect } from 'react-redux';
import { getPrimaryAccount } from "../../../../../../../utils/sessionUtil";
import { recordError } from "../../../../../../../utils/commonUtil";
import { withRouter } from "react-router-dom";
import { isReadOnlyWithExchangeRole } from "../../../../RecommendAnExchangeNew/util";

export class ExchangesCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: false,
      id: '',
    }
    this.handlePop = this.handlePop.bind(this);

  }
  cancelSingle() {
    this.setState({ popup: !this.state.popup })
    this.props.cancelTxnSchedule(
      {
        method: "POST",
        page: "exchangeActivity",
        url: `/donor-portal/api/exchange/${getPrimaryAccount().userId}/cancelSingleExchange?exchangeId=${this.state.id}`,
      }
    )
  }

  handlePop(id) {

    this.setState({ popup: !this.state.popup, id })
  };


  render() {
    const { data, id } = this.props;
    let exchangeStartDate = moment(moment.tz(data.exchangeStartDate, "America/New_York")).format("L");

    let tradeDate = moment(moment.tz(data.tradeDate, "America/New_York")).format("L");
    let isLCP = data.exchangetype.includes('Low Carbon Global Equity')

    return (
      <div>
        <AlertMessagePrimary
          data-test="alert-msg"
          title="Cancel Exchange"
          visible={this.state.popup}
          onCancel={() => this.handlePop()}
          onOk={() => this.cancelSingle()}
          width={800}
          cancelText="No, take me back"
          okText="CONTINUE"
        >
          Are you sure you want to cancel this exchange? Selecting continue will cancel the Exchange.
        </AlertMessagePrimary>

        <Row>
          <Col span={12}>
            <LabelDataHeading>Entered Date</LabelDataHeading>
            <ValueDataHeading>
              {exchangeStartDate === "Invalid date" ? (
                <div>&mdash;</div>
              ) : (
                  exchangeStartDate
                )}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Exchange Type</LabelDataHeading>
            <ValueDataHeading>{data.exchangetype}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Trade Date</LabelDataHeading>
            <ValueDataHeading>
              {tradeDate === "Invalid date" ? <div>&mdash;</div> : tradeDate}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Allocation Type</LabelDataHeading>
            <ValueDataHeading>{data.allocationType ? data.allocationType.toLowerCase() : null}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Status</LabelDataHeading>
            <ValueDataHeading>{data.status.extDescription}</ValueDataHeading>
          </Col>
          <Col className="singleEx-img" span={2}>
            {data.isRecurring === true ?
              <Tooltip
                placement="bottom"
                title={"Indicates that this is part of a recurring exchange schedule."}
              >
                <img alt="RecurringIcon" src={RecurringIcon} />
              </Tooltip>
              : ""}
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={8}>
          
            {data.status.description === "Entered" && (getPrimaryAccount().role.access === "All Access" || isReadOnlyWithExchangeRole()) ? (
              <ViewMoreButton
                disabled={isLCP}
                id={id && ("btnviewAndEdit" + id)}
                data-test="view-more-1"
                onClick={e => {
                  try {
                    e.stopPropagation();
                    switch (data.exchangetype) {
                      case "From TIFF":
                        history.push({
                          pathname: `/view-edit-tiff-from/${data.txnId}/edit`
                        });
                        break;
                      case "To TIFF":
                        history.push({
                          pathname: `/view-edit-tiff-into/${data.txnId}/edit`
                        });
                        break;
                      default:
                        history.push({
                          pathname: `/investments/recommend-an-exchange/${data.txnId}`,
                          search: `type=onetime`,
                          state: { txn: data, page: "edit" }
                        });
                        break;
                    }
                  } catch (error) {
                    recordError(error);
                  }
                }}

              >
                View & Edit
              </ViewMoreButton>
            ) : (
                <ViewMoreButton
                  disabled={isLCP}
                  data-test="view-more-2"
                  id={id && ("btnView" + id)}
                  onClick={e => {
                    try {
                      e.stopPropagation();
                      switch (data.exchangetype) {
                        case "From TIFF":
                          history.push({
                            pathname: `/view-edit-tiff-from/${data.txnId}/view`
                          });
                          break;
                        case "To TIFF":
                          history.push({
                            pathname: `/view-edit-tiff-into/${data.txnId}/view`
                          });
                          break;
                        default:
                          history.push({
                            pathname: `/investments/recommend-an-exchange/${data.txnId}`,
                            search: `type=onetime`,
                            state: { txn: data }
                          });
                          break;
                      }
                    } catch (error) {
                      recordError(error);
                    }
                  }}
                >View&nbsp;</ViewMoreButton>
              )}
          </Col>
          <Col span={8} offset={4}>
          {(data.status.description === "Entered") && (getPrimaryAccount().role.access === "All Access" || isReadOnlyWithExchangeRole()) ? (
            <Underlined data-test="cancel-underlined" onClick={()=>{this.handlePop(data.txnId)}} id={id && "anrUnderLined"+id}>Cancel</Underlined>): <> </>}
          </Col>
        </Row>
      </div>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  cancelTxnSchedule: data => dispatch(cancelTxnSchedule(data)),

});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(ExchangesCard)
);
